import React from 'react';
import { useTranslations } from 'next-intl';

import { StyledPanoImageSkeleton } from './panoImage.style';

const PanoImageSkeleton = () => {
  const t = useTranslations();
  return <StyledPanoImageSkeleton>{t('panoImage.loading')}</StyledPanoImageSkeleton>;
};

export default PanoImageSkeleton;
